import { Navigate, Route, Routes } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";
import HomePage from "../pages/home/HomePage";
import AboutPage from "../pages/about/AboutPage";
import ContactPage from "../pages/contact/ContactPage";
import TermsPage from "../pages/terms/TermsPage";
import PolicyPage from "../pages/policy/PolicyPage";
import ImprintPage from "../pages/imprint/ImprintPage";
import GetItPage from "../pages/getIt/GetItPage";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="getItApp" element={<GetItPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="policy" element={<PolicyPage />} />
        <Route path="imprint" element={<ImprintPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;
